export const RESIDENCY_ROUTE_NAMES = {
  LIST: 'residencyList',
  DETAIL: 'residencyDetail',
}

export const RESIDENCY_ROUTE_NAMES_NEW = {
  LIST: 'residencyListNew',
  DETAIL: 'residencyDetailNew',
}
